import React, { SVGProps } from 'react';

export const SearchAIIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M16.3,17.4c-.1,0-.3,0-.4-.2l-3-3.5c-1.3,1.2-3,1.9-4.8,1.9-3.8,0-7-3.1-7-7S4.3,1.8,8.2,1.8s.5.2.5.5-.2.5-.5.5c-3.3,0-6,2.7-6,6s2.7,6,6,6,6-2.7,6-6,.2-.5.5-.5.5.2.5.5c0,1.6-.6,3.1-1.5,4.3l3,3.5c.2.2.2.5,0,.7,0,0-.2.1-.3.1Z"
    />
    <path
      fill="currentColor"
      d="M12.4,8.4c-.2,0-.4-.1-.5-.3l-.2-.7c-.3-.8-.5-1.2-.7-1.5-.2-.2-.7-.4-1.5-.7l-.7-.2c-.2,0-.3-.3-.3-.5s.1-.4.3-.5l.7-.2c.9-.3,1.2-.5,1.5-.7.2-.2.4-.7.7-1.5l.2-.7c0-.2.3-.3.5-.3h0c.2,0,.4.1.5.3l.2.7c.3.8.5,1.2.7,1.5.2.2.6.4,1.5.7l.7.2c.2,0,.3.3.3.5s-.1.4-.3.5l-.7.2c-.8.3-1.2.5-1.5.7-.2.2-.4.7-.7,1.5l-.2.7c0,.2-.3.3-.5.3ZM10.4,4.5c.6.2.9.4,1.2.7.3.3.5.7.7,1.2.2-.6.4-.9.7-1.2.3-.3.7-.5,1.2-.7-.6-.2-.9-.4-1.2-.7-.3-.3-.5-.7-.7-1.2-.2.6-.4.9-.7,1.2-.3.3-.7.5-1.2.7Z"
    />
  </svg>
);
